import { Card, CardContent, CardHeader, Grid, IconButton, Box, Button, Typography } from '@mui/material';
import { Add, Delete } from '@mui/icons-material';
import { CustomProduct } from './custom-product';

interface ICustomProductFieldsProps {
  index: number;
  removeCustomProduct: (index: number) => () => void;
  isLastCustomProduct: boolean;
  addCustomProduct: () => void;
}
export function CustomProductFields({
  index,
  removeCustomProduct,
  isLastCustomProduct,
  addCustomProduct,
}: ICustomProductFieldsProps) {
  const CardSubHeader = () => (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
      }}
    >
      <Typography
        sx={theme => ({
          marginRight: theme.spacing(2),
        })}
      >
        {`#${index + 1}`}
      </Typography>
    </Box>
  );

  return (
    <Grid xs={12} item>
      <Card>
        <CardHeader
          action={
            <IconButton onClick={removeCustomProduct(index)}>
              <Delete />
            </IconButton>
          }
          subheader={<CardSubHeader />}
        />
        <CardContent>
          <CustomProduct index={index} />

          {isLastCustomProduct && (
            <Button
              sx={{ marginTop: '25px' }}
              onClick={addCustomProduct}
              variant='outlined'
              startIcon={<Add fontSize='large' />}
            >
              Add Custom Product
            </Button>
          )}
        </CardContent>
      </Card>
    </Grid>
  );
}
